export const SUPPORTED_LOCALES = ['en', 'de', 'bg'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
